export default __webpack_public_path__ + "static/logo-PB-d5b835fec5d952ef52e53fc0784497d8.png";